import { useContext, /* useState,  */ useEffect } from 'react';
import { GlobalContext } from '../../../store/Store';
import meshApi from '../../../apis/meshApi';
import ActionType from '../../../store/ActionType';
import { IProgressItem } from '../../mike-topbar-progress-spinner';
import useLocalStorage from '../../app/Polling/PollingStorage';

const BROWSERSTEP = 33;
export default function PlatformImportProgress({ meshesToImport }: { meshesToImport }) {
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const [, setPollingSettings] = useLocalStorage('polling-settings');

  const dispatchFile = (fn: string, progressValue: number) => {
    const data: IProgressItem = {
      title: `Importing ${fn}`,
      progressValue,
      browserStep: BROWSERSTEP,
      id: fn,
    };

    globalDispatch({
      type: ActionType.ADD_POLLING_ITEM,
      data,
    });

    return data;
  };

  const importPlatformMeshes = async names => {
    const projectGuid = globalState.project.currentProject.id;

    names.forEach(async fn => {
      const importItem = dispatchFile(fn.name, 0);
      const sourceProjectGuid = fn.projectId;
      try {
        await meshApi
          .importPlatformMeshes({
            projectGuid,
            sourceProjectGuid,
            meshNames: [fn.name],
          })
          .then(response => {
            const boundaryItem: IProgressItem = {
              title: `Starting boundary extraction`,  
              id: (response.data as any).MeshImportStatuses[0].BoundaryExtractionJobGuid,
              progressValue: 0,
              browserStep: 0,
            };
            const meshTilingItem: IProgressItem = {
              title: `Starting mesh tiling extraction`,         
              id: (response.data as any).MeshImportStatuses[0].MeshTilingJobGuid,
              progressValue: 0,
              browserStep: 0,
            };
            const meshTilingOrgItem: IProgressItem = {
              title: `Starting mesh tiling org. extraction`,      
              id: (response.data as any).MeshImportStatuses[0].MeshTilingOriginalJobGuid,
              progressValue: 0,
              browserStep: 0,
            };

            //Clean up import dispatch and continue polling with new dispatches
            globalDispatch({
              type: ActionType.RM_POLLING_ITEM,
              data: { ...importItem },
            });

            globalDispatch({
              type: ActionType.SET_POLLING_UPDATE, 
              data: (response.data as any).MeshImportStatuses[0].BoundaryExtractionJobGuid,
            });
            globalDispatch({
              type: ActionType.SET_POLLING_UPDATE,     
              data: (response.data as any).MeshImportStatuses[0].MeshTilingJobGuid,
            });
            globalDispatch({
              type: ActionType.SET_POLLING_UPDATE,      
              data: (response.data as any).MeshImportStatuses[0].MeshTilingOriginalJobGuid,
            });

            globalDispatch({
              type: ActionType.ADD_POLLING_ITEM,
              data: boundaryItem,
            });
            globalDispatch({
              type: ActionType.ADD_POLLING_ITEM,
              data: meshTilingItem,
            });
            globalDispatch({
              type: ActionType.ADD_POLLING_ITEM,
              data: meshTilingOrgItem,
            });

            setPollingSettings([
              ...globalState.pollingIds,   
              (response.data as any).MeshImportStatuses[0].BoundaryExtractionJobGuid,   
              (response.data as any).MeshImportStatuses[0].MeshTilingJobGuid,       
              (response.data as any).MeshImportStatuses[0].MeshTilingOriginalJobGuid,
            ]);
          });
      } catch (_err) {
        console.log('_err', _err);

        const err = _err as Error;
        // Show error message:
        globalDispatch({
          type: ActionType.SET_MESSAGE,
          message: String(err),
        });
        globalDispatch({ type: ActionType.SET_SHOW_MESSAGE, show: true });
        globalDispatch({ type: ActionType.SET_MESSAGE_TYPE, messagetype: 'error' });

        // Remove dispatch item from spinner due to failure
        globalDispatch({
          type: ActionType.RM_POLLING_ITEM,
          data: { ...importItem },
        });
      }
    });
  };

  useEffect(() => {
    if (meshesToImport.length > 0) {
      importPlatformMeshes(meshesToImport);
    }
  }, [meshesToImport]);

  return <span></span>;
}
